"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdatesOnlyEffect = exports.default = void 0;
var _react = require("react");
const useUpdatesOnlyEffect = (callback, deps) => {
  const mounted = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    if (mounted.current) {
      callback();
    } else {
      mounted.current = true;
    }
  }, deps);
};
exports.useUpdatesOnlyEffect = useUpdatesOnlyEffect;
var _default = exports.default = useUpdatesOnlyEffect;